import React, { Component } from "react";
import AtlasList from "../components/atlas/atlas";
import {
  getAtlasList,
  getColumnList,
  getDelId,
  getRecId,
  getAllReport,
  filterCheckedColumn,
  getFindId,
  getEditorColumnList,
  addColumn,
} from "../../actions/convergenceMedia";
import { connect } from "react-redux";
import * as utils from "../../utils/index";
import clickEdit from "../../view/components/atlas/CmClickEdit"
import "antd/dist/antd.css";
import { HEADER_HEIGHT } from "../../constants";
import { Scrollbars } from "react-custom-scrollbars";
import {
  Button,
  Input,
  Row,
  Col,
  Checkbox,
  Pagination,
  TreeSelect,
  Modal,
  message,
  Empty
} from "antd";
const { Search } = Input;

const typeList = [
  {
    title: "全部",
    value: "0",
    key: "0",
  },
  {
    title: "暂存",
    value: "1",
    key: "1",
  },
  {
    title: "已发布",
    value: "2",
    key: "2",
  },
  {
    title: "已撤回",
    value: "3",
    key: "3",
  },
  {
    title: "发布失败",
    value: "4",
    key: "4",
  },
];

class Atlas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      start: 1, //当前页
      size: 10, //每页条数
      dataList: [], //数据源,
      listTotal: 0, //列表总数
      selectKey: "0", //栏目筛选
      selectAddKey: "0", //添加至栏目筛选
      columnList: [], //栏目列表
      typeKey: "0", //状态筛选
      typeList: [], //状态列表
      searchValue: null, //搜索文字
      allChoose: false, //全选
      visible: false,
      listId: [],
      userDate: [], //用户数据
      filterColumn: [], //过滤栏目列表
      editorColumnList: [],
    };
  }
  componentDidMount() {
    this.pageChange();
    this.getColumnLists();
  }

  // 点击清空
  clearNull = () => {
    this.setState({
      start: 1,
      size: 10
    })
    // 不能用this.setstate()来将selectKey置为0
    this.state.selectKey = "0";
    this.pageChange();
  };
  // 点击删除
  delete(id) {
    this.deleteItemId(id);
  };
  // 获取删除数据
  deleteItemId(delId) {
    let params = {
      mfId: delId,
    };
    getDelId(params, (res) => {
      if (res) {
        message.success("删除成功");
        this.pageChange();
      } else {
        message.error("删除失败");
      }
    });
  }
  // 获取撤回数据
  getRecall(recId) {
    let params = {
      mfId: recId,
    };
    getRecId(params, (res) => {
      if (res) {
        message.success("撤回成功");
        this.pageChange();
      } else {
        message.error("撤回失败");
      }
    });
  }
  // 点父选全部子
  allChoose() {
    // 改变子组件选中
    if (this.state.allChoose) {
      this.state.dataList.forEach((item) => {
        item.checked = false;
      });
    } else {
      this.state.dataList.forEach((item) => {
        item.checked = true;
      });
    }
    // 改变父组件自己选中状态
    this.state.allChoose = !this.state.allChoose;
    // 更新
    this.setState({});
  }

  // 点子操作父
  itemClick(item, index) {
    // 把每条数据的显示状态给每条数据对应下标的显示状态
    this.state.dataList[index].checked = !item.checked;
    // 获取数据源的长度
    let numMax = this.state.dataList.length;
    // 初始选中的长度
    let num = 0;
    // 遍历数据源判断
    this.state.dataList.forEach((item) => {
      // 如果一个子未选中，则父不选中
      if (item.checked === false) {
        this.state.allChoose = false;
      } else {
        // 子长度加1
        num++;
      }
    });
    // 如果子长度等于数据源的长度，则父状态按钮显示
    if (numMax === num) {
      this.state.allChoose = true;
    }
    // 更新
    this.setState({});
  }
  // 获取栏目数据
  getColumnLists() {
    getColumnList((res) => {
      if (res) {
        this.state.columnList = res;
      }
      this.getList(this.state.columnList);
      this.setState({
        columnList: this.state.columnList,
      });
    });
  }

  // 递归调用，初始化栏目数据
  getList = (data) => {
    data.forEach((item) => {
      item.title = item.columnName;
      item.value = item.id;
      item.key = item.id;
      if (item.children && item.children.length > 0) {
        this.getList(item.children); //取嵌套数据
      }
    });
  };
  // 添加至栏目
  addToColumn = () => {
    let ids = []
    if (!this.state.allChoose) {
      //未全选
      let flag = false;
      this.state.dataList &&
        this.state.dataList.length > 0 &&
        this.state.dataList.forEach((item) => {
          if (item.checked) {
            flag = true;
            ids.push(item.id)
            this.showModal(ids);
          }
        });
      if (!flag) {
        message.info("请先选择融媒信息");
      }
    }
  };

  showModal = (listId) => {
    this.setState({
      visible: true,
      listId,
    });
  };

  handleOk = () => {
    this.getAddColumns(this.state.listId, this.state.selectAddKey);
    this.setState({
      visible: false,
    });
    this.state.selectAddKey = "0"
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };
  // 重置
  reset = () => {
    this.setState({
      start: 1,
      size: 10
    })
    this.state.selectKey = "0"
    this.state.typeKey = "0"
    this.state.searchValue = null
    this.pageChange()
  }
  // 渲染
  render() {
    console.log(this)
    let newSecondSelectColor =
      this.props.config && this.props.config.getValueByKey
        ? this.props.config.getValueByKey("newSecondSelectColor", "#0050B3")
        : "#0050B3";
    let height = window.innerHeight - HEADER_HEIGHT; //浏览器窗口的内部高度-顶部导航的高度(上部分70) 
    const { columnList } = this.state;
    return (
      <div
        style={{
          padding: "10px 20px",
          backgroundColor: "#fff",
          margin: "10px 10px",
        }}
      >
        {/* 头部 */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {/* 左侧 */}
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <div>
              <Button
                type="primary"
                style={{
                  background: newSecondSelectColor,
                  borderColor: newSecondSelectColor,
                }}
                onClick={() => clickEdit.gotoPage(5, 0)}
              >
                +发图集
              </Button>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div>
                <span style={{ margin: "0px 15px" }}>筛选</span>
                <span style={{ marginRight: "15px" }}>|</span>
              </div>
              <div style={{ width: "200px" }}>
                <TreeSelect
                  dropdownStyle={{ height: "170px" }}
                  style={{ width: "200px" }}
                  placeholder="请选择栏目"
                  value={
                    this.state.selectKey === "0" ? null : this.state.selectKey
                  }
                  treeData={columnList}
                  onChange={(value) => {
                    this.state.selectKey = value;
                    this.state.page = 1;
                    this.state.size = 10;
                    this.setState({});
                    this.pageChange();
                  }}
                />
              </div>
              <div>
                <span style={{ marginLeft: "15px", cursor: "pointer" }} onClick={this.clearNull}>
                  清空
                  </span>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div>
                <span style={{ marginLeft: "25px", marginRight: "15px" }}>
                  状态
                </span>
              </div>
              <div style={{ width: "200px" }}>
                <TreeSelect
                  style={{ width: "200px" }}
                  value={this.state.typeKey}
                  treeData={typeList}
                  onChange={(value) => {
                    this.state.typeKey = value;
                    this.state.page = 1;
                    this.state.size = 10;
                    this.setState({});
                    this.pageChange();
                  }}
                />
              </div>
            </div>
          </div>
          {/* 右侧 */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ color: "#0050B3" }}>
              <Button onClick={this.addToColumn}>添加至栏目</Button>
            </div>
            <Modal
              title="选择栏目"
              visible={this.state.visible}
              onOk={this.handleOk}
              onCancel={this.handleCancel}
              bodyStyle={{ height: "300px" }}
            >
              <div style={{ width: "200px", margin: "0 auto" }}>
                <TreeSelect
                  dropdownStyle={{ height: "200px" }}
                  style={{ width: "200px" }}
                  searchPlaceholder="点击选择栏目"
                  value={
                    this.state.selectAddKey === "0" ? null : this.state.selectAddKey
                  }
                  treeCheckable={true}
                  treeData={columnList}
                  onChange={(value) => {
                    this.state.selectAddKey = value;
                    this.setState({});
                  }}
                />
              </div>
            </Modal>
            <div style={{ width: "200px", marginLeft: "20px" }}>
              <Search
                placeholder="请输入搜索内容"
                onSearch={(value) => this.onSearch(value)}
                value={this.state.searchValue}
                onChange={(e) => {
                  this.setState({
                    searchValue: e.target.value,
                  });
                }}
                style={{ width: 200 }}
              />
            </div>
            <div
              style={{ marginLeft: "20px", }}>
              <Button
                onClick={this.reset}
                type="primary"
                style={{
                  background: newSecondSelectColor, borderColor: newSecondSelectColor
                }}>重置</Button>
            </div>
          </div>
        </div>
        {/* 列表 */}
        <div
          style={{ border: "1px solid #ccc", padding: "5px", marginTop: "7px" }}
        >
          <Row justify="start">
            {/* 全选 */}
            <Col span={12}>
              <Checkbox
                style={{ marginRight: "20px" }}
                onClick={() => {
                  this.allChoose();
                }}
                checked={this.state.allChoose}
              />
              标题
            </Col>
            <Col span={2} style={{ textAlign: "center" }}>
              原创
            </Col>
            <Col span={2} style={{ textAlign: "center" }}>
              主题
            </Col>
            <Col span={2} style={{ textAlign: "center" }}>
              状态
            </Col>
            <Col span={2} style={{ textAlign: "center" }}>
              最新修改时间
            </Col>
            <Col span={2} style={{ textAlign: "center" }}>
              热度
            </Col>
            <Col span={2} style={{ textAlign: "center" }}>
              操作
            </Col>
          </Row>
        </div>
        {/* 处理滚动条的方法以及自适应 */}
        <div style={{ height: height - 145, background: "white" }}>
          <Scrollbars ref={(Scrollbars) => (this.scrollRef = Scrollbars)}>
            {/* 循环组件 */}
            {/* 无数据时显示为暂无数据 */}
            {
              this.state.dataList.length === 0 ? <Empty style={{ position: "absolute", top: "45%", left: "45%" }} /> : null
            }
            {
              this.state.dataList.map((item, index) => {
                return (
                  <AtlasList
                    key={item.id}
                    newSecondSelectColor={newSecondSelectColor}
                    columnList={this.state.columnList}
                    title={item.title}
                    desc={item.describe}
                    coverPic={item.coverPic}
                    labelNames={item.labelNames}
                    mfAccount={item.mfAccount}
                    mfAccountType={item.mfAccountType}
                    source={item.source}
                    status={item.status}
                    pictureList={item.pictureList}
                    viewNum={item.viewNum}
                    likeNum={item.likeNum}
                    id={item.id}
                    type={item.type}
                    mediaFusionId={item.mediaFusionId}
                    getRecall={(recID) => this.getRecall(recID)}
                    userDate={this.state.userDate}
                    filterColumn={this.state.filterColumn}
                    forwardNum={item.forwordNum}
                    newTime={
                      item.updateDate && item.updateDate.time
                        ? utils.formatDate(item.updateDate.time) //转化时间
                        : ""
                    }
                    myClick={() => this.delete(item.id)} //删除
                    checked={item.checked} //拿到每条数据的checked属性
                    ItemClick={() => {
                      this.itemClick(item, index); //传一个操作每条数据的方法
                    }}
                    filterCheckedColumns={() => this.filterCheckedColumns()}
                    getAllReports={() => this.getAllReports()}
                    // getFindIds={(id) => this.getFindIds(id)}
                    getEditorColumnLists={() => this.getEditorColumnLists()}
                    editorColumnList={this.state.editorColumnList}
                    getClickPublish={(obj) => this.getClickPublish(obj)}
                    locale={{ emptyText: '暂无数据' }}
                  />
                );
              })}
          </Scrollbars>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "10px",
          }}
        >
          <Pagination
            hideOnSinglePage={true}
            showQuickJumper
            current={this.state.start}
            pageSize={this.state.size}
            total={this.state.listTotal}
            showTotal={(total) => `共 ${total} 条`}
            showSizeChanger
            onChange={(page, pageSize) => this.onChange(page, pageSize)} //页码改变时回调
            onShowSizeChange={(page, pageSize) => {
              this.onChange(page, pageSize); //每页条数改变回调
            }}
          />
        </div>
      </div>
    );
  }
  // 页面改变时回调
  onChange(page, pageSize) {
    this.state.start = page;
    this.state.size = pageSize;
    // 每次改变页码时
    this.pageChange();
  }
  // 得到个人数据
  getAllReports() {
    getAllReport((res) => {
      if (res) {
        this.setState({
          userDate: res.data,
        });
      }
    });
  }
  // 获取过滤栏目数据
  filterCheckedColumns() {
    let params = {
      checkedColumn: "",
      passMediaCodes: "",
    };
    filterCheckedColumn(params, (res) => {
      if (res) {
        this.setState({
          filterColumn: res,
        });
      }
    });
  }
  // 获取点击编辑每条数据
  // getFindIds(id) {
  //   getFindId(id, (res) => {
  //   });
  // }
  // 获取编辑栏目数据
  getEditorColumnLists() {
    getEditorColumnList((res) => {
      if (res) {
        this.state.editorColumnList = res;
        this.getList(this.state.editorColumnList);
        this.setState({
          editorColumnList: this.state.editorColumnList,
        });
      }
    });
  }
  pageChange() {
    //先取出变量
    let body = {
      start: this.state.start,
      size: this.state.size,
      type: 2,
      source: 0,
      sort: "updateDate",
    };
    // 给body强制添加参数
    if (this.state.selectKey) {
      body.columnId = this.state.selectKey;
    }
    if (this.state.typeKey) {
      body.status = this.state.typeKey;
    }
    if (this.state.searchValue) {
      body.queryStr = this.state.searchValue;
    }
    getAtlasList(body, (res) => {
      let dataList = [];
      let listTotal = 0; //列表总数
      if (res && res.data) {
        dataList = res.data;
        // 遍历数据源给每条数据添加checked属性
        dataList.forEach((item) => {
          item.checked = false;
        });
        listTotal = res.count;
      }
      this.setState({
        dataList: dataList,
        listTotal: listTotal,
      });
    });
    // 分页时清空全选按钮
    this.setState({
      allChoose: false,
    });
  }

  //搜索
  onSearch(value) {
    this.state.searchValue = value;
    this.state.start = 1;
    this.state.size = 10;
    this.pageChange();
  }
  // 点击确定时添加值栏目数据
  getAddColumns(listId, colId) {
    let params = {
      ids: listId,
      columnIds: colId,
    };
    addColumn(params, (res) => {
      if (res) {
        message.info("加入成功");
        this.pageChange();
      } else {
        message.error("加入失败");
      }
    });
  }
}
function mapStateToProps(state) {
  // 将state中的systeReducer的config放入props中,使实例对象能操作
  return {
    config: state.systemReducer.config,
  }
}

export default connect(mapStateToProps)(Atlas);